import { safeLocalStorage as u, REFERENCE_LS_KEYS as n } from "@scalar/helpers/object/local-storage";
import { generateClientMutators as m } from "@scalar/workspace-store/client";
import { onCustomEvent as s } from "@scalar/workspace-store/events";
const k = (r, t) => {
  const v = m(r);
  s(t, "scalar-update-dark-mode", (e) => {
    r.update("x-scalar-dark-mode", e.detail.value);
  }), s(t, "scalar-update-active-document", (e) => {
    r.update("x-scalar-active-document", e.detail.value);
  }), s(t, "scalar-update-selected-client", (e) => {
    r.update("x-scalar-default-client", e.detail), u().setItem(n.SELECTED_CLIENT, e.detail);
  }), s(t, "scalar-replace-servers", (e) => {
    var c;
    const a = r.workspace.activeDocument;
    a && (a.servers = e.detail.servers, a["x-scalar-active-server"] = (c = e.detail.servers.at(-1)) == null ? void 0 : c.url);
  }), s(t, "scalar-update-selected-server", (e) => {
    const a = r.workspace.activeDocument;
    a && (a["x-scalar-active-server"] = e.detail.value);
  }), s(t, "store-update-selected-server-properties", (e) => {
    var l;
    const a = r.workspace.activeDocument;
    if (!a)
      return;
    const c = (l = a.servers) == null ? void 0 : l.find((i) => i.url === a["x-scalar-active-server"]);
    c && (c[e.detail.key] = e.detail.value);
  }), s(t, "scalar-update-selected-server-variables", (e) => {
    var l, i;
    const a = r.workspace.activeDocument;
    if (!a)
      return;
    const c = (l = a.servers) == null ? void 0 : l.find((d) => d.url === a["x-scalar-active-server"]);
    c && (i = c.variables) != null && i[e.detail.key] && (c.variables[e.detail.key].default = e.detail.value);
  }), s(t, "scalar-add-server", (e) => {
    v.active().serverMutators.addServer(e.detail.server);
    const a = r.workspace.activeDocument;
    a && (a["x-scalar-active-server"] = e.detail.server.url);
  }), s(t, "scalar-delete-server", (e) => {
    v.active().serverMutators.deleteServer(e.detail.url);
  });
};
export {
  k as useWorkspaceStoreEvents
};
